import * as React from 'react'
import { applyAtPath, IBaseProperty, IUIPropertyDefinition } from '../common'
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle, TextAlignEditor } from './common'
import jp from 'jsonpath'
import { Input } from 'uxp/components'
import { bindContainerId, hasProperty, hasValue } from '../../../util'
import { WidgetDesignerPillInput } from '../pill-input/PillInput'
import { $L } from '../../../localize';
export interface ITextProperty extends IBaseProperty {
    text?: string,
    color?: string
    size?: string,
    align?: string
}

export function extractTextProperties(props: ITextProperty, defaultText?: string): { text: string, styles: React.CSSProperties } {
    if (!props) return { text: defaultText || '', styles: {} }
    let { color, size, align } = props

    let text = hasValue(props.text) ? props.text : (defaultText || '')

    let styles: React.CSSProperties = {}
    if (hasValue(color)) styles.color = color
    if (hasValue(size)) styles.fontSize = size
    if (hasValue(align)) styles.textAlign = align as any

    return { text, styles }
}

export function TextProperty(defaultProps: ITextProperty, title?: string): IUIPropertyDefinition<ITextProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, contextData, containerId) => {

            let _props = props?.uiProps || { text: '' }

            return <PropertyContainer>
                <PropertyContainerTitle>{title || $L('widgetdesigner.props.text', 'Text')}</PropertyContainerTitle>
                <PropertyGroup>
                    {hasProperty(defaultProps, '$.text') &&
                        <Property id={bindContainerId('text', containerId)}>
                            <PropertyTitle>{$L('widgetdesigner.props.text', 'Text')}</PropertyTitle>
                            {/* <Input
                                value={_props.text || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.text', () => (s))
                                    props.onChange(Object.assign({},_props));
                                }}
                                className="widget-designer-input"
                            /> */}

                            <WidgetDesignerPillInput
                                value={_props.text || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.text', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                contextData={contextData}
                            />
                        </Property>
                    }
                    {hasProperty(defaultProps, '$.color') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.color', 'Color')}</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.color || ''}
                                onChange={s => {
                                    let newProps = applyAtPath(_props, '$.color', () => (s))
                                    props.onChange(newProps)
                                }}
                            />
                        </Property>
                    }
                    {
                        hasProperty(defaultProps, '$.size') && <>
                            <Property>
                                <PropertyTitle>{$L('widgetdesigner.props.size-px', 'Size (px)')} </PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(_props.size || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'

                                        let newProps = applyAtPath(_props, '$.size', () => (s + 'px'))
                                        props.onChange(newProps)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>

                        </>
                    }

                    {
                        hasProperty(defaultProps, '$.align') && <>
                            <Property>
                                <PropertyTitle>{$L('widgetdesigner.props.align', 'Align')}</PropertyTitle>
                                <TextAlignEditor
                                    value={_props.align || ''}
                                    onChange={s => {
                                        let newProps = applyAtPath(_props, '$.align', () => (s))
                                        props.onChange(newProps)
                                    }}
                                />
                            </Property>
                        </>
                    }

                </PropertyGroup>
            </PropertyContainer>
        }
    }

}